import { Container, Card} from "react-bootstrap";
import Layout from "../components/Layout";
import zoho from "../assets/images/accounting/zoho.png";
import quickbooks from "../assets/images/accounting/quickbooks.png";
import xero from "../assets/images/accounting/xero.png";
import freshbooks from "../assets/images/accounting/freshbooks.jpg";
import sage from "../assets/images/accounting/sage.png";

const Accounting = () => {
 
    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <div className="mt-4">
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="table-responsive">
                            <div className="text-center">
                                <h5>
                                  Integrate your account softwares here
                                </h5>
                                <div className="row mt-4">
                                    {[
                                        { name: 'QuickBooks', logo: quickbooks },
                                        { name: 'Sage', logo: sage },
                                        { name: 'Zoho', logo: zoho },
                                        { name: 'FreshBooks', logo: freshbooks },
                                        { name: 'Xero', logo: xero },
                                    ].map((software) => (
                                        <div key={software.name} className="col-md-4 col-lg-2 mb-3">
                                            <div className="text-center p-3 border rounded h-100" style={{ minHeight: '150px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                    <img src={software.logo} alt={software.name} width={100} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        </Layout>
    );
}

export default Accounting;